import ServicePhoto1 from '../Images/Services/services1.jpeg';
import ServicePhoto2 from '../Images/Services/services2.jpeg';
import ServicePhoto3 from '../Images/Services/services3.jpeg';
import ServicePhoto4 from '../Images/Services/services4.jpeg';
import ServicePhoto5 from '../Images/Services/services5.jpeg';
import ServicePhoto6 from '../Images/Services/services6.jpeg';

function Services() {
    return(
        <div>
            <br/><br/>
            <h2><b>Service Area</b></h2>
            <h3><b>We Serve:</b></h3>
            <h4 className='hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                <ul style={{textAlign: "left", marginLeft: "30%"}}>
                    <li>Washington DC</li><br/>
                    <li>Maryland</li><br/>
                    <li>Virginia</li><br/>
                </ul>
            <br/><br/>
            </h4>
            <h4 className='visible-xs visible-sm'>
                <br/>
                <ul style={{textAlign: "left"}}>
                    <li>Washington DC</li><br/>
                    <li>Maryland</li><br/>
                    <li>Virginia</li><br/>
                </ul>
            </h4>
            <br/>

            <h2><b>Services We Provide</b></h2>
            <h3><b>Residential and Commercial Plumbing</b></h3>
            <h4 className='hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                <ul style={{textAlign:"left", marginLeft: "30%"}}>
                    <li>Leak detection & repair</li><br/>
                    <li>Faucet, toilet & fixture installation</li><br/>
                    <li>Drain cleaning & snaking</li><br/>
                    <li>Pipe repair & replacement</li><br/>
                    <li>Water heater service</li><br/>
                </ul>
            <br/><br/>
            </h4>
            <h4 className='visible-xs visible-sm'>
                <br/>
                <ul style={{textAlign: "left"}}>
                    <li>Leak detection & repair</li><br/>
                    <li>Faucet, toilet & fixture installation</li><br/>
                    <li>Drain cleaning & snaking</li><br/>
                    <li>Pipe repair & replacement</li><br/>
                    <li>Water heater service</li><br/>
                </ul>
                <br/><br/>
            </h4>

            <h3><b>Emergency Services</b></h3>
            <h4 className='hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                <ul style={{textAlign: "left", marginLeft: "30%"}}>
                    <li>Burst pipes</li><br/>
                    <li>Backups</li><br/>
                    <li>No hot water</li><br/>
                    <li>Flooding</li><br/>
                </ul>
            <br/><br/>
            </h4>
            <h4 className='visible-xs visible-sm'>
                <br/>
                <ul style={{textAlign: "left"}}>
                    <li>Burst pipes</li><br/>
                    <li>Backups</li><br/>
                    <li>No hot water</li><br/>
                    <li>Flooding</li><br/>
                    </ul>
                <br/><br/>
            </h4>

            <h3><b>Maintenence</b></h3>
            <h4 className='hidden-xs hidden-sm' style={{fontSize:"175%"}}>
                <br/>
                <ul style={{textAlign: "left", marginLeft: "30%"}}>
                    <li>Preventative inspections</li><br/>
                    <li>Seasonal plumbing checks</li><br/>
                </ul>
            <br/><br/>
            </h4>
            <h4 className='visible-xs visible-sm'>
                <br/>
                <ul style={{textAlign: "left"}}>
                    <li>Preventative inspections</li><br/>
                    <li>Seasonal plumbing checks</li><br/>
                </ul>
                <br/><br/>
            </h4>

            <h2><b>Some Photos of Our Work</b></h2>
            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={ServicePhoto1}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={ServicePhoto1}/>
            <h3 className='menu-item-text'>Domestic Water Backflow & Control Assembly</h3>

            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={ServicePhoto2}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={ServicePhoto2}/>
            <h3 className='menu-item-text'>Under-Sink Water Control & Mixing Assembly</h3>

            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={ServicePhoto3}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={ServicePhoto3}/>
            <h3 className='menu-item-text'>Overhead Drainage & Vent System Installation</h3>

            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={ServicePhoto4}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={ServicePhoto4}/>
            <h3 className='menu-item-text'>Mechanical Room - Copper Piping & Water Heater System</h3>

            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={ServicePhoto5}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={ServicePhoto5}/>
            <h3 className='menu-item-text'>Commercial Rough-In Plumbing Installation</h3>

            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={ServicePhoto6}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={ServicePhoto6}/>
            <h3 className='menu-item-text'>Precision Sink Installation - Finished Trim</h3>
        </div>
    )
}
export default Services;